import { useSignal, useComputed, useSignalEffect } from "@preact/signals-react";
import { useTranslation } from "react-i18next";
import { ASSESSMENT_SUBJECT_SELF } from "components/Assessment/Subject";
import { OptionButtons } from "components/Form/OptionButtons";

export function AssessmentWorries({
  assessmentSubject,
  defaultOption = null,
  defaultText = '',
  className = '',
  onAnswer = () => {},
  onNext = () => {},
}) {
  const { t } = useTranslation();
  const hasWorries = useSignal(defaultOption);
  const worries = useSignal(defaultText);

  useSignalEffect(() => {
    onAnswer({
      worries: worries.value,
      hasWorries: hasWorries.value,
    });
  });

  const openQuestion = useComputed(() => {
    const textFieldClassNames = ['field-wrapper'];
    if (hasWorries.value !== true) {
      textFieldClassNames.push('visually-hidden-custom');
    }
    return (
      <div className={textFieldClassNames.join(' ')}>
        <form onSubmit={(e) => {
          e.preventDefault();
          onAnswer({
            worries: worries.value,
            hasWorries: hasWorries.value,
          });
          onNext(); // signal to parent component that this question is done
        }}>
          <input
            type="text"
            placeholder={t(
              assessmentSubject.value === ASSESSMENT_SUBJECT_SELF
                ? 'please fill in your worries'
                : 'please fill in the assessment subject\'s worries'
            )}
            defaultValue={worries.value}
            onChange={(e) => {worries.value = e.target.value}}
          />
        </form>
      </div>
    );
  });

  return (
    <div className={className}>
      <p>{t(
        assessmentSubject.value === ASSESSMENT_SUBJECT_SELF
          ? 'what are your worries about the future'
          : 'what are your assessment subject\'s worries about the future'
      )}</p>
      <OptionButtons
        className="options"
        defaultOption={hasWorries.value}
        options={[
          { label: t('yes, i have'), value: true },
          { label: t('no, i have not'), value: false },
        ]}
        onSelect={(value) => hasWorries.value = value}
      />
      {openQuestion}
    </div>
  )
}

export default AssessmentWorries;